<script setup>
import axios from 'axios'
import {useRoute, useRouter} from 'vue-router'
import {ref, onMounted, nextTick, computed} from "vue";
import {Icon} from "@iconify/vue";

const route = useRoute()
const id = route.query.id
const message = route.query.message

const API_KEY = "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"

const isLoading = ref(false)
const responseText = ref('')
const stores = ref([])
const router = useRouter()

const fetchChatCompletion = async () => {
  isLoading.value = true
  try {
    const res = await axios.get(
        `https://api.openai.com/v1/chat/completions/${id}/messages`,
        {
          headers: {
            "Authorization": `Bearer ${API_KEY}`,
            "Content-Type": "application/json"
          },
          timeout: 300000
        }
    );

    const messages = res.data?.data || [];

    const formattedMessages = messages.map(msg => ({
      id: msg.id,
      role: msg.role,
      content: msg.content
    }));

    //console.log(formattedMessages);

    const lastMessage = formattedMessages.at(-1)?.content || '❌ پاسخی دریافت نشد';
    responseText.value = lastMessage;

    stores.value.push({
      id,
      model: res.data?.model || 'unknown',
      total_tokens: res.data?.usage?.total_tokens || 0,
      prompt_tokens: res.data?.usage?.prompt_tokens || 0,
      completion_tokens: res.data?.usage?.completion_tokens || 0,
      message: lastMessage
    });

    await nextTick();
  } catch (err) {
    console.error("API Error:", err);
    responseText.value = "⚠️ خطا در ارتباط با سرور";
  } finally {
    isLoading.value = false;
  }
}

function back() {
  router.push({name: 'ChatGpt'})
}

const cleanedMessage = computed(() => {
  const msg = stores.value?.[0]?.message
  if (!msg) return "No message found"

  // remove "\"
  const unescaped = msg.replace(/\\n/g, '\n').replace(/\\"/g, '"')

  // find json
  const jsonMatch = unescaped.match(/\[.*\]/s)
  if (!jsonMatch) return unescaped

  try {
    const parsed = JSON.parse(jsonMatch[0])
    const pretty = JSON.stringify(parsed, null, 2)
    return unescaped.replace(jsonMatch[0], pretty)
  } catch {
    return unescaped
  }
})

onMounted(() => {
  fetchChatCompletion()
})
</script>

<template>
  <div class="h-full overflow-y-auto custom-scrollbar">
    <div class="pr-2 text-white">
      <div class="flex flex-row gap-2">
        <div class="back-btn" @click="back">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
               class="w-4 h-4 2xl:w-6 2xl:h-6">
            <path fill="currentColor"
                  d="m7.825 13l4.9 4.9q.3.3.288.7t-.313.7q-.3.275-.7.288t-.7-.288l-6.6-6.6q-.15-.15-.213-.325T4.426 12t.063-.375t.212-.325l6.6-6.6q.275-.275.688-.275t.712.275q.3.3.3.713t-.3.712L7.825 11H19q.425 0 .713.288T20 12t-.288.713T19 13z"/>
          </svg>
        </div>
        <h2 class="text-2xl font-bold mb-4">GPT Details</h2>
      </div>

      <div class="bg-[#1a2941] p-4 rounded mb-6">
        <p><strong>ID:</strong> {{ id }}</p>
        <p class="mt-2 whitespace-pre-wrap">
          <strong>Message:</strong><br/>
          {{ cleanedMessage }}
        </p>
      </div>

      <div v-if="isLoading" class="flex justify-center items-center h-32">
        <Icon icon="eos-icons:bubble-loading" class="size-10 text-blue-400"/>
      </div>

      <div v-else>
        <h3 class="text-lg font-semibold mb-2">Response from GPT:</h3>
        <pre class="bg-[#162338] text-slate-200 p-4 rounded whitespace-pre-wrap">
          {{ message }}
        </pre>
      </div>
    </div>
  </div>
</template>

<style scoped>
pre {
  font-family: 'Fira Code', monospace;
  font-size: 0.85rem;
}

.back-btn {
  @apply h-6 2xl:h-8 w-6 2xl:w-8 bg-slate-200 dark:bg-slate-700 dark:text-slate-200 text-slate-600 flex flex-col justify-center items-center text-base rounded-full cursor-pointer;
}
</style>
